import { render, staticRenderFns } from "./empreendedor.vue?vue&type=template&id=13845ba4"
import script from "./empreendedor.vue?vue&type=script&lang=js"
export * from "./empreendedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports